type CategoryIconMap = {
  [key: string]: string;
};

/**
 * Map of category names to Font Awesome icon classes
 */
const categoryIcons: CategoryIconMap = {
  appetizers: 'fas fa-cheese',
  starters: 'fas fa-carrot',
  salads: 'fas fa-leaf',
  soups: 'fas fa-utensil-spoon',
  'main courses': 'fas fa-drumstick-bite',
  'main-courses': 'fas fa-drumstick-bite',
  mains: 'fas fa-drumstick-bite',
  seafood: 'fas fa-fish',
  pasta: 'fas fa-bread-slice',
  pizza: 'fas fa-pizza-slice',
  burgers: 'fas fa-hamburger',
  sandwiches: 'fas fa-bread-slice',
  sides: 'fas fa-bacon',
  vegetables: 'fas fa-carrot',
  desserts: 'fas fa-ice-cream',
  cocktail: 'fas fa-glass-martini-alt',
  champagne: 'fas fa-champagne-glasses',
  drinks: 'fas fa-glass-martini-alt',
  'soft drinks': 'fas fa-glass-whiskey',
  'hot drinks': 'fas fa-coffee',
  coffee: 'fas fa-coffee',
  tea: 'fas fa-mug-hot',
  wine: 'fas fa-wine-glass-alt',
  beer: 'fas fa-beer',
  cocktails: 'fas fa-martini-glass-citrus',
  spirits: 'fas fa-wine-bottle',
  specials: 'fas fa-star',
  'daily specials': 'fas fa-star',
  breakfast: 'fas fa-egg',
  lunch: 'fas fa-utensils',
  dinner: 'fas fa-concierge-bell',
  snacks: 'fas fa-cookie',
  'kids menu': 'fas fa-child',
  kids: 'fas fa-child',
  vegan: 'fas fa-seedling',
  vegetarian: 'fas fa-leaf',
  'gluten-free': 'fas fa-ban',
  spicy: 'fas fa-pepper-hot',
  all: 'fas fa-utensils',
};

/**
 * Get the icon class for a given category
 * @param category The category name (case-insensitive)
 * @returns The Font Awesome icon class
 */
export function getCategoryIcon(category: string): string {
  const categoryLower = category.toLowerCase();
  
  switch (categoryLower) {
    case 'starters':
      return 'fas fa-bread-slice';
    case 'main courses':
      return 'fas fa-utensils';
    case 'desserts':
      return 'fas fa-ice-cream';
    case 'wine':
      return 'fas fa-wine-glass-alt';
    case 'beer':
      return 'fas fa-beer';
    case 'cocktails':
      return 'fas fa-martini-glass';
    case 'spirits':
      return 'fas fa-wine-bottle';
    case 'champagne':
      return 'fas fa-wine-glass-alt';
    case 'soft drinks':
      return 'fas fa-glass-whiskey';
    case 'hot drinks':
      return 'fas fa-mug-hot';
    case 'all':
      return 'fas fa-utensils';
    default:
      return categoryIcons[categoryLower] || 'fas fa-utensils';
  }
}

/**
 * Get all available category icons
 * @returns Object mapping category names to icon classes
 */
export const getAllCategoryIcons = (): CategoryIconMap => {
  return { ...categoryIcons };
};

/**
 * Check if a category has a custom icon
 * @param category The category name (case-insensitive)
 * @returns boolean indicating if the category has a custom icon
 */
export const hasCustomIcon = (category: string): boolean => {
  const normalized = category.toLowerCase().trim();
  return normalized in categoryIcons;
};

/**
 * Add a custom category icon
 * @param category The category name (case-insensitive)
 * @param iconClass The Font Awesome icon class
 */
export const addCategoryIcon = (category: string, iconClass: string): void => {
  const normalized = category.toLowerCase().trim();
  categoryIcons[normalized] = iconClass;
};

export default {
  getCategoryIcon,
  getAllCategoryIcons,
  hasCustomIcon,
  addCategoryIcon
};